import * as React from "react";
import { TextField } from "@origin-digital/ods-core";
import { Search } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { RenderInputParams } from "@material-ui/lab";
import content from "../../cms/searchbar.json";

interface ISearchBarProps {
  onBlur: () => void;
  loading: boolean;
  params: RenderInputParams;
}
const useStyles = makeStyles((theme) => ({
  SearchInput: {
    "& .MuiAutocomplete-input": {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: "6px",
      height: "22px",
    },
    "& .MuiFilledInput-underline:before": {
      borderColor: theme.palette.grey[300],
    },
    "& .MuiFilledInput-underline:after": {
      borderColor: theme.palette.grey[300],
    },
    "& .MuiFilledInput-underline:hover:before": {
      borderColor: theme.palette.grey[300],
    },
    "& .MuiCircularProgress-root": {
      marginRight: "-12px",
    },
    "& .MuiAutocomplete-inputRoot": {
      padding: "0 30px 1px 12px",
      fontSize: "inherit",
      height: "56px",
      backgroundColor: theme.palette.common.white,
    },
  },
}));

const SearchIcon = (): JSX.Element => (
  <React.Fragment>
    <Search className="search-icon" fontSize="default" color="inherit" />
  </React.Fragment>
);

const Spinner = (): JSX.Element => (
  <React.Fragment>
    <CircularProgress color="inherit" size={20} />
  </React.Fragment>
);

export const SearchInputField = ({
  params,
  loading,
  onBlur,
}: ISearchBarProps): JSX.Element => {
  const classes = useStyles({});
  return (
    <TextField
      {...params}
      hideHelperTextSpace={true}
      data-id="search-input"
      onBlur={onBlur}
      className={classes.SearchInput}
      classes={{ root: "search-input" }}
      muiProps={{
        InputProps: {
          ...params.InputProps,
          placeholder: content.placeholder,
          startAdornment: <SearchIcon />,
          endAdornment: loading ? <Spinner /> : null,
        },
      }}
    />
  );
};
